import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import RecoverForm from "./RecoverForm";

function formatErr(detail) {
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg).filter(Boolean).join(" ");
  return "Login gagal, coba lagi";
}

export default function AdminLogin() {
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [recover, setRecover] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await api.post("/auth/login", form);
      localStorage.setItem("puspita_admin_token", data.token);
      toast.success("Selamat datang, Admin");
      navigate("/admin/products");
    } catch (err) {
      setError(formatErr(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F4EFE6] flex items-center justify-center px-4">
      <div className="w-full max-w-sm bg-[#FBF9F5] rounded-3xl border border-[#DACFBE] shadow-md p-8">
        <div className="text-center mb-8">
          <span className="w-12 h-12 rounded-full bg-[#3D5A40] text-[#FBF9F5] inline-flex items-center justify-center font-bold text-lg shadow-sm">
            P
          </span>
          <h1 className="font-serif-display text-2xl font-bold text-[#1E2B1D] mt-4">
            Puspita Florist
          </h1>
          <p className="text-xs text-[#6B7C66] mt-1 uppercase tracking-widest">{recover ? "Pulihkan Kata Sandi" : "Panel Admin"}</p>
        </div>
        {recover ? (
          <RecoverForm onBack={() => setRecover(false)} formatErr={formatErr} />
        ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="admin-login-form">
          <div>
            <label className="block text-xs font-bold uppercase tracking-wider text-[#354634] mb-2">
              Email Admin
            </label>
            <input
              type="email"
              required
              value={form.email}
              onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))}
              data-testid="admin-email-input"
              placeholder="admin@puspitaflorist.com"
              className="w-full px-4 py-3 rounded-xl border border-[#D5CCBC] bg-white text-sm text-[#1E2B1D] focus:outline-none focus:ring-2 focus:ring-[#3D5A40]"
            />
          </div>
          <div>
            <label className="block text-xs font-bold uppercase tracking-wider text-[#354634] mb-2">
              Kata Sandi
            </label>
            <input
              type="password"
              required
              value={form.password}
              onChange={(e) => setForm((f) => ({ ...f, password: e.target.value }))}
              data-testid="admin-password-input"
              placeholder="••••••••"
              className="w-full px-4 py-3 rounded-xl border border-[#D5CCBC] bg-white text-sm text-[#1E2B1D] focus:outline-none focus:ring-2 focus:ring-[#3D5A40]"
            />
          </div>
          {error && (
            <p data-testid="admin-login-error" className="text-xs text-red-600 bg-red-50 rounded-lg px-3 py-2">
              {error}
            </p>
          )}
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="w-full py-3.5 rounded-xl bg-[#3D5A40] hover:bg-[#2E4530] disabled:opacity-50 text-[#FAF7EE] font-bold text-sm transition-colors shadow-md"
          >
            {loading ? "Memproses..." : "Masuk ke Dashboard"}
          </button>
          <button
            type="button"
            onClick={() => { setRecover(true); setError(""); }}
            data-testid="forgot-password-link"
            className="w-full text-xs text-[#6B7C66] hover:text-[#3D5A40] transition-colors"
          >
            Lupa kata sandi? Gunakan kode pemulihan
          </button>
        </form>
        )}
        <a
          href="/"
          data-testid="back-to-store-link"
          className="block text-center text-xs text-[#6B7C66] hover:text-[#3D5A40] mt-6 transition-colors"
        >
          ← Kembali ke Toko
        </a>
      </div>
    </div>
  );
}
